module.exports = __webpack_public_path__ + "img/6.81bec66b.webp";